import axiosApi from "../axiosInstance";
import { getReduxCompany } from "../../helper/sessionHelper";


export async function GetWorkFlowForApprovalForIom(request) {
    try {
        request = request || {};
        request.companyId = getReduxCompany()?.companyId || 0;

        const response = await axiosApi.post(`/WorkFlow/GetWorkFlowForApprovalForIom`, request);
        return response?.data?.data;
    } catch (error) {
        console.log("Error GetWorkFlowForApprovalForIom===>:", error);
        return error?.response?.data?.data;
    }
};